import React, { useState } from 'react';
import './Navbar.css';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../Context/Authcontext';
import { FaInstagram, FaFacebookF, FaAmazon } from 'react-icons/fa';

/* ── Brand SVG icons (Arcticons style) for platforms not in react-icons ── */
const MyntraIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="20" height="20" aria-label="Myntra">
    <ellipse cx="28.311" cy="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" rx="13.871" ry="4.22" transform="rotate(-68.92 28.311 24)"/>
    <path fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M32.727 24.215q.227.647.48 1.303c2.756 7.148 6.752 12.263 8.927 11.425s1.703-7.312-1.052-14.46s-6.752-12.264-8.927-11.426"/>
    <ellipse cx="10.856" cy="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" rx="13.871" ry="4.22" transform="rotate(-68.92 10.856 24)"/>
    <path fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M15.272 24.215q.227.647.48 1.303c2.06 5.343 4.812 9.55 6.98 10.984M24 23.49q-.18-.501-.374-1.008c-2.756-7.148-6.752-12.263-8.927-11.425"/>
  </svg>
);

const MeeshoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="20" height="20" aria-label="Meesho">
    <path fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      d="M18.9 32.4c-.3.6-.9 1-1.6 1c-1 0-1.9-.9-1.9-1.9v-1.2c0-1.1.9-1.9 1.9-1.9s1.8.8 1.9 1.9v.7h-3.8m9.6 1.4c-.3.6-.9 1-1.6 1c-1 0-1.9-.9-1.9-1.9v-1.2c0-1.1.8-1.9 1.9-1.9s1.9.8 1.9 1.9v.8h-3.8m6.3 1.8c.4.3 1 .4 1.5.4h.4c.7 0 1.2-.5 1.3-1.2c0-.7-.5-1.2-1.2-1.3q0 0 0 0h-.9c-.7 0-1.2-.5-1.3-1.2c0-.7.5-1.2 1.2-1.3q0 0 0 0h.4c.9 0 1.2.1 1.5.4m2.6-3v7.6m0-3.1c0-1 .9-1.9 1.9-1.9h0c1 0 1.9.9 1.9 1.9v3.1m4.2 0c-1 0-1.9-.9-1.9-1.9v-1.2c0-1.1.8-1.9 1.9-1.9c1 0 1.9.8 1.9 1.9v1.3c0 1-.8 1.8-1.9 1.8m-32.5 6c.3 1.2 1.4 2 2.6 2h25.2c1.2 0 2.3-.8 2.6-2m4.2-15.5c.4-1.6-.5-3.2-2.1-3.6c-.3-.1-.5-.2-.8-.2H33L25.6 7.7c-.5-.9-1.7-1.3-2.6-.7c-.3.2-.6.4-.7.7L14.9 20H7.5c-1.6 0-3 1.3-3 3c0 .3 0 .5.1.8M24 12.4l4.5 7.6h-9.1zM5.5 30.2c0-1.1.9-1.9 1.9-1.9h0c1.1 0 1.9.9 1.9 1.9v3.1m-3.8-5v5.1m3.8-3.2c0-1.1.9-1.9 1.9-1.9h0c1.1 0 1.9.9 1.9 1.9v3.1"/>
  </svg>
);

const NykaaIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="20" height="20" aria-label="Nykaa">
    <circle cx="24" cy="24" r="21.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="m11 35.99l12-23.98v23.98l12-24M32 32h2.6m-2.604 4v-8h4"/>
  </svg>
);

const socials = [
  { href: "https://www.instagram.com/pentadeco?igsh=eXUzajJ6aDFlZmJy", icon: <FaInstagram />, label: "Instagram" },
  { href: "https://www.facebook.com/share/19Ybv3kWMc/", icon: <FaFacebookF />, label: "Facebook" },
  { href: "https://www.amazon.in/stores/PENTADECO/page/5CBF87B7-1BD3-4475-B3A1-1CF4DF594BAD?lp_asin=B0CR3P8MVX&ref_=cm_sw_r_apann_ast_store_XSQVQMQDQR4670Z6PQN9&dplnk=Y&dplnkId=46cad73e-5796-4ef9-8a50-5fe95e2a184b", icon: <FaAmazon />, label: "Amazon" },
  { href: "https://www.myntra.com/pentadeco?p=1", icon: <MyntraIcon />, label: "Myntra" },
  { href: "https://share.google/9KUjVxdWXHUrgIZZW", icon: <MeeshoIcon />, label: "Meesho" },
  { href: "https://www.nykaa.com/brands/pentadeco/c/58333", icon: <NykaaIcon />, label: "Nykaa" },
];

function Navbar() {
  const { isloggedin, bardis, userdata } = useAuth();
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();

  const toggleNav = () => setNavOpen(!navOpen);
  const closeNav = () => setNavOpen(false);

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Overlay */}
      {navOpen && <div className="overlay-menu" onClick={closeNav}></div>}

      {/* Promo strip – home only */}
      {location.pathname === '/' && (
        <Link to="/product" className="nav-link w-100 d-flex align-items-center justify-content-center py-2" style={{backgroundColor: '#5C3A1E'}}>
          <p className="mb-0 text-white body-font-bold text-center letter-spacing promo-strip-text">
            UPTO 40% OFF ON ALL PRODUCTS &nbsp;—&nbsp; SHOP NOW
          </p>
        </Link>
      )}

      {/* COD strip – mobile only */}
      {window.innerWidth < 800 && (
        <div className="w-100 d-flex align-items-center justify-content-center bg-brand-secondary py-1">
          <img src="/assets/money.png" alt="cash on delivery" width={22} className="me-2" />
          <p className="mb-0 lh-sm text-white fs-sm">Cash On Delivery Available!</p>
        </div>
      )}

      <nav className="navbar navbar-expand-lg bg-white border-bottom py-3">
        <div className="container-fluid d-flex justify-content-between align-items-center px-4">

          {/* Logo */}
          <Link to="/" style={{ maxWidth: 'min(180px, 45%)' }}>
            <img src="/assets/penta-logo.png" alt="Pentadeco" className="me-4 w-100" />
          </Link>

          {/* Desktop nav links */}
          <div className="d-none d-lg-flex align-items-center gap-4">
            {[
              { label: 'Home',     path: '/'        },
              { label: 'Products', path: '/product'  },
              { label: 'About',    path: '/about'    },
              { label: 'Orders',   path: '/orders'   },
              { label: 'Contact',  path: '/contact'  },
            ].map(({ label, path }) => (
              <Link
                key={path}
                to={path}
                className={`nav-desktop-link${isActive(path) ? ' active' : ''}`}
              >
                {label}
              </Link>
            ))}
          </div>

          {/* Right icons */}
          <div className="d-flex align-items-center">
            {/* COD pill – desktop */}
            <div className="d-none d-lg-flex align-items-center border rounded-pill px-3 py-1 me-4" style={{gap: '8px'}}>
              <img src="/assets/money.png" alt="COD" width={24} />
              <p className="mb-0 lh-sm fs-sm text-nowrap">Cash On Delivery</p>
            </div>

            <div className="d-flex align-items-center gap-3">
              {/* Cart */}
              <Link to="/cart" className="nav-link nav-icon-btn" style={{position: 'relative'}}>
                <i className="fas fa-shopping-bag fs-5 text-dark"></i>
                {userdata?.cart?.length > 0 && (
                  <span className="cart-badge">
                    {userdata.cart.reduce((t, i) => t + i.quantity, 0)}
                  </span>
                )}
              </Link>

              {/* Profile */}
              {isloggedin && (
                <Link to="/profile" className="nav-link nav-icon-btn">
                  <i className="fas fa-user fs-5 text-dark"></i>
                </Link>
              )}

              {/* Hamburger */}
              <div className="d-lg-none cursor-pointer nav-icon-btn" onClick={toggleNav}>
                <i className="fas fa-bars fs-4 text-dark"></i>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Slide-out Mobile Menu */}
      <div className={`mobile-menu ${navOpen ? 'open' : ''}`}>
        <div className="d-flex flex-column justify-content-between p-4 pt-3 h-100">
          <div>
            <Link to="/" onClick={closeNav}>
              <img src="/assets/penta-logo.png" width={160} alt="logo" className="mb-4 d-block" />
            </Link>
            {[
              { label: 'Home',       path: '/'        },
              { label: 'Products',   path: '/product'  },
              { label: 'About',      path: '/about'    },
              { label: 'Orders',     path: '/orders'   },
              { label: 'Contact Us', path: '/contact'  },
            ].map(({ label, path }) => (
              <Link key={path} to={path} onClick={closeNav} className="mobile-nav-link">
                {label}
              </Link>
            ))}
          </div>

          <div>
            <p className="mb-1 fs-esm">
              <span className="body-font-bold">Phone:</span>{' '}
              <Link to="tel:+917738494171" className="nav-link d-inline">+91 77384 94171</Link>
            </p>
            <p className="mb-2 fs-esm">
              <span className="body-font-bold">Address:</span> Kalyan, Kongaon, Maharashtra 421311
            </p>
            <div className="d-flex gap-2 mb-3 flex-wrap">
              {socials.map(({ href, icon, label }) => (
                <a key={label} href={href} target="_blank" rel="noreferrer" className="mobile-social-icon" title={label}>
                  {icon}
                </a>
              ))}
            </div>
            <p className="mb-0 fs-esm text-muted">&copy; 2025 Pentadeco. All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Navbar;
